import { render, staticRenderFns } from "./SlabModal.vue?vue&type=template&id=78b5f95e&scoped=true&"
import script from "./SlabModal.vue?vue&type=script&lang=js&"
export * from "./SlabModal.vue?vue&type=script&lang=js&"
import style0 from "./SlabModal.vue?vue&type=style&index=0&id=78b5f95e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b5f95e",
  null
  
)

export default component.exports